import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Header } from '../../header';
import { useNotify } from "tailwind-notifications-react";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

export const SettingsPage = () => {
    const navigate = useNavigate();
    const notify = useNotify();

    const [concerts, setConcerts] = useState([]);
    const [merchPage, setMerchPage] = useState({ title: '', computerPreview: '', mobilePreview: '' });
    const [track, setTrack] = useState({ name: '', preview: '', link: '', button: '' });
    const [allTags, setAllTags] = useState([]);
    const [priorityTags, setPriorityTags] = useState([]);
    const token = localStorage.getItem('token');

    useEffect(() => {
        fetchSettings();
        fetchTags();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await axios.get('https://api.alyonatestsite.store/api/settings', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const settings = response.data;

            setConcerts(settings.concerts || []);
            setMerchPage(settings.merchPage || { title: '', computerPreview: '', mobilePreview: '' });
            setTrack(settings.track || { name: '', preview: '', link: '', button: '' });
            setPriorityTags(settings.priorityTags || []);

        } catch (error) {
            console.error('Ошибка загрузки настроек:', error);
        }
    };

    const fetchTags = async () => {
        try {
            const response = await axios.get('https://api.alyonatestsite.store/api/tags');
            setAllTags(response.data);
        } catch (error) {
            console.error('Ошибка загрузки тегов:', error);
        }
    };

    const handleSaveSettings = async () => {
        const formData = new FormData();
    
        formData.append("concerts", JSON.stringify(concerts));
        formData.append("merchPage", JSON.stringify(merchPage));
        formData.append("track", JSON.stringify(track));
        formData.append("priorityTags", JSON.stringify(priorityTags));
    
        if (merchPage.computerPreview instanceof File) {
            formData.append("merchPageComputerPreview", merchPage.computerPreview);
        }
        if (merchPage.mobilePreview instanceof File) {
            formData.append("merchPageMobilePreview", merchPage.mobilePreview);
        }
        if (track.preview instanceof File) {
            formData.append("trackPreview", track.preview);
        }
    
        try {
            await axios.put("https://api.alyonatestsite.store/api/settings", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                }
            });
            notify({
                title: "Успешно",
                message: `Настройки сайта успешно обновлены.`,
                type: "success",
            });
            navigate('/dashboard/settings');
        } catch (error) {
            console.error("Ошибка сохранения настроек:", error);
        }
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        
        const items = Array.from(priorityTags);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        
        setPriorityTags(items);
    };

    const toggleTagSelection = (tag) => {
        const isSelected = priorityTags.some(t => t.id === tag.id);
        if (isSelected) {
            setPriorityTags(priorityTags.filter(t => t.id !== tag.id));
        } else {
            setPriorityTags([...priorityTags, tag]);
        }
    };

    const isTagSelected = (tag) => {
        return priorityTags.some(t => t.id === tag.id);
    };

    return (
        <section className="bg-white">
            <Header fixed={false} />

            <div className="p-8 max-w-6xl mx-auto">
                <h1 className="font-bold text-2xl mb-4">Редактирование настроек сайта</h1>

                <div className="flex flex-col gap-8">
                    <div className="bg-gray-50 p-6 rounded-lg">
                        <h2 className="font-bold text-xl mb-4">Концерты</h2>
                        {concerts.map((concert, index) => (
                            <div key={index} className="flex flex-col gap-2 mb-6 p-4 bg-white rounded">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Дата</label>
                                        <input
                                            type="text"
                                            value={concert.date}
                                            onChange={(e) => {
                                                const updatedConcerts = [...concerts];
                                                updatedConcerts[index].date = e.target.value;
                                                setConcerts(updatedConcerts);
                                            }}
                                            className="w-full p-2 border border-gray-300 rounded"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Место проведения</label>
                                        <input
                                            type="text"
                                            placeholder="Место проведения"
                                            value={concert.place}
                                            onChange={(e) => {
                                                const updatedConcerts = [...concerts];
                                                updatedConcerts[index].place = e.target.value;
                                                setConcerts(updatedConcerts);
                                            }}
                                            className="w-full p-2 border border-gray-300 rounded"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Ссылка</label>
                                        <input
                                            type="text"
                                            placeholder="Ссылка"
                                            value={concert.link}
                                            onChange={(e) => {
                                                const updatedConcerts = [...concerts];
                                                updatedConcerts[index].link = e.target.value;
                                                setConcerts(updatedConcerts);
                                            }}
                                            className="w-full p-2 border border-gray-300 rounded"
                                        />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Превью</label>
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            const updatedConcerts = [...concerts];
                                            updatedConcerts[index].preview = e.target.files[0];
                                            setConcerts(updatedConcerts);
                                        }}
                                        className="w-full p-2 border border-gray-300 rounded"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg">
                        <h2 className="font-bold text-xl mb-4">Страница мерча</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Заголовок</label>
                                <input
                                    type="text"
                                    placeholder="Заголовок"
                                    value={merchPage.title}
                                    onChange={(e) => setMerchPage({ ...merchPage, title: e.target.value })}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Превью для компьютера</label>
                                <input
                                    type="file"
                                    onChange={(e) => setMerchPage({ ...merchPage, computerPreview: e.target.files[0] })}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Превью для мобильных</label>
                                <input
                                    type="file"
                                    onChange={(e) => setMerchPage({ ...merchPage, mobilePreview: e.target.files[0] })}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg">
                        <h2 className="font-bold text-xl mb-4">Приоритетные теги для каталога</h2>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <h3 className="font-medium mb-2">Доступные теги</h3>
                                <div className="flex flex-wrap gap-2">
                                    {allTags.map(tag => (
                                        <button
                                            key={tag.id}
                                            onClick={() => toggleTagSelection(tag)}
                                            className={`px-3 py-1 font-crooker rounded-full text-sm ${isTagSelected(tag) 
                                                ? 'bg-sky-500 text-white' 
                                                : 'bg-gray-200 text-gray-800'}`}
                                            style={isTagSelected(tag) ? { backgroundColor: `#${tag.color}` } : {}}
                                        >
                                            {tag.name}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            
                            <div>
                                <h3 className="font-medium mb-2">Выбранные теги (порядок приоритета)</h3>
                                {priorityTags.length > 0 ? (
                                    <DragDropContext onDragEnd={handleDragEnd}>
                                        <Droppable droppableId="priorityTags">
                                            {(provided) => (
                                                <div 
                                                    {...provided.droppableProps} 
                                                    ref={provided.innerRef}
                                                    className="space-y-2"
                                                >
                                                    {priorityTags.map((tag, index) => (
                                                        <Draggable key={tag.id} draggableId={String(tag.id)} index={index}>
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className="flex items-center p-2 bg-white border rounded shadow-sm"
                                                                >
                                                                    <span className="mr-2 text-gray-500">≡</span>
                                                                    <span 
                                                                        className="px-2 py-1 font-crooker rounded-full text-sm text-white"
                                                                        style={{ backgroundColor: `#${tag.color}` }}
                                                                    >
                                                                        {tag.name}
                                                                    </span>
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setPriorityTags(priorityTags.filter(t => t.id !== tag.id));
                                                                        }}
                                                                        className="ml-auto text-gray-500 hover:text-red-500"
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                ) : (
                                    <p className="text-gray-500 text-sm">Нет выбранных тегов</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg">
                        <h2 className="font-bold text-xl mb-4">Трек</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Название трека</label>
                                <input
                                    type="text"
                                    placeholder="Название трека"
                                    value={track.name}
                                    onChange={(e) => setTrack({ ...track, name: e.target.value })}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Превью трека</label>
                                <input
                                    type="file"
                                    onChange={(e) => setTrack({ ...track, preview: e.target.files[0] })}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Ссылка на трек</label>
                                <input
                                    type="text"
                                    placeholder="Ссылка на трек"
                                    value={track.link}
                                    onChange={(e) => setTrack({ ...track, link: e.target.value })}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Название кнопки</label>
                                <input
                                    type="text"
                                    placeholder="Название кнопки"
                                    value={track.button}
                                    onChange={(e) => setTrack({ ...track, button: e.target.value })}
                                    className="w-full p-2 border border-gray-300 rounded"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button
                            onClick={handleSaveSettings}
                            className="bg-sky-500 hover:bg-sky-600 text-white px-6 py-2 rounded-lg transition-colors"
                        >
                            Сохранить настройки
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};